import { Component, effect, Inject, OnInit, ViewChild, inject } from '@angular/core';
import { Accordion } from 'primeng/accordion';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { CategoryBinderAssembly } from 'src/app/models/category-binder-assembly';
import { BinderAssembliesService } from 'src/app/services/app/binder-assemblies.service';
import { UserAccessService } from 'src/app/services/app/user-access.service';
import { DOCUMENT } from '@angular/common';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { SkeletonModule } from 'primeng/skeleton';
import { LandmarkAssemblyGroupComponent } from './components/assembly-group.component';
import { CardModule } from 'primeng/card';
import { MenubarModule } from 'primeng/menubar';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { AssemblyFinderService } from '@/services/app/assembly-finder.service';
import { AssemblyImportService } from '../assembly-import/assembly-import.service';
import { CatalogService } from '@/services/api/catalog.service';
import { BinderService } from '@/services/api/binder.service';

@Component({
    selector: 'app-binder-assemblies',
    imports: [
        CommonModule,
        ButtonModule,
        AccordionModule,
        SkeletonModule,
        LandmarkAssemblyGroupComponent,
        CardModule,
        MenubarModule,
    ],
    template: `
    <div class="card">
    <div class="card-header gap-4">
                <div class="card-title">
                <span class="text-2xl font-bold">Assemblies</span>
                </div>
                <div class="flex align-items-center gap-2">
                <p-button icon="pi pi-clipboard" [text]="true" [raised]="true" (click)="pasteAssembly()" pTooltip="Paste assemblies from clipboard" [disabled]="!userAccessService.binderEditAccess()" tooltipPosition="left"/>
                <!-- <app-landmark-assembly-picker></app-landmark-assembly-picker> -->
                <p-button (click)="showAssembliesDialog()" label="Add" icon="pi pi-plus" [raised]="true" severity="primary" [disabled]="!userAccessService.binderEditAccess()"/>
        
        </div>
      </div>
    <p-accordion *ngIf="binderAssembliesService.binderAssemblies() && !binderService.isLoading()" #accordion [value]="0">
        <p-accordion-panel *ngFor="let category of binderAssembliesService.groupedAssemblies()" class="accordionTab" [value]="category.CategoryID">
        <p-accordion-header>
          <span class="flex align-items-center gap-2 w-full">
                <span class="font-bold white-space-nowrap">{{category.Name}}</span>
                <span class="ml-auto mr-3" *ngIf="category.optionsCount > 0 || category.total > 0">{{category.total | currency}} from {{category.optionsCount}} assemblies</span>
            </span>  
          </p-accordion-header>
          <p-accordion-content>
          <app-landmark-assembly-group [assemblies]="category.assemblies"></app-landmark-assembly-group>
          </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
  </div>`,
})
export class BinderAssembliesComponent implements OnInit {
  clonedAssemblies: { [s: string]: CategoryBinderAssembly } = {};
  // @ViewChild('accordion') accordion!: Accordion;
  private document: Document;
  showPicker = false;

  constructor(
    private binderDialogService: BinderDialogService,
    public binderAssembliesService: BinderAssembliesService,
    public userAccessService: UserAccessService,
    private assemblyImportService: AssemblyImportService,
    private assemblyFinderService: AssemblyFinderService,
    private catalogService: CatalogService,
    public binderService: BinderService
  ) {
    this.document = inject(DOCUMENT); 
// effect(() => {
//   const assembly = this.assemblyFinderService.assembly();
//   if(assembly) {
//     this.scrollToAssembly(assembly.CategoryID, assembly.BAID);
//   }
// });

// effect(() => {
//   const assembly = this.catalogService.selectedAssembly();
//   if(assembly) {
//     this.showAssemblyDialog();
//   }
// });
  }

  ngOnInit(): void {
    this.document.addEventListener('paste', this.onPaste.bind(this));
  }

  onPaste(event: ClipboardEvent): void {
    this.pasteAssembly();
  }

  pasteAssembly() {
    this.assemblyImportService.importAssemblyFromClipboard();
  }

  toggleCollapse(collapseId: string): void {
    const collapseElement = document.getElementById(collapseId);
    if (collapseElement) {
      collapseElement.classList.toggle('show');
    }
  }

  showAssembliesDialog() {
    this.binderDialogService.toggleDrawer('assemblies', 'Add Assemblies', true);
  }

  scrollToAssembly(categoryId: number, assemblyId: number) {
    const categoryIndex = this.binderAssembliesService.groupedAssemblies().findIndex((category: CategoryBinderAssembly) => category.CategoryID === categoryId);
    if (categoryIndex !== -1) {
      setTimeout(() => {
        // this.accordion.activeIndex = categoryIndex;
        const element = document.getElementById(`assembly-${assemblyId}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          element.classList.add('flash');
          setTimeout(() => {
            element.classList.remove('flash');
          }, 2000);
        }
      });
    }
    
  }

  getAssemblyCount(assemblies: BinderAssembly[]) {
    const options = assemblies.filter(a => a.Type !== 'S');
    let total = 0;
  
    for (const assembly of options) {
      const price = assembly.Price != null ? parseFloat(assembly.Price.toString()) : 0;
      const quantity = assembly.Quantity != null ? parseFloat(assembly.Quantity.toString()) : 0;
  
      if (!isNaN(price) && !isNaN(quantity)) {
        total += price * quantity;
      }
    }
  
    if (options.length === 0) return '';
  
    const formattedTotal = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total);
    return `${formattedTotal} from ${options.length} assemblies`;
  }
  

}
